/**
 * Copyright Aquera Inc 2023
 *
 * This source code is licensed under the BSD-3-Clause license found in the
 * LICENSE file in the root directory of this source tree.
 */

import { css } from 'lit';

/**
 * ButtonToggleGroup CSS
 */
export const styles = css`
  :host {
    display: inline-flex;
    border-radius: var(--nile-radius-none, var(--ng-radius-md));
    border:var(--nile-border-style-none), var(--ng-border-width-1) var(--ng-border-style-solid) var(--ng-colors-border-primary);
    box-shadow: var(--nile-box-shadow-1, var(--ng-shadow-xs-skeuomorphic));
    -webkit-font-smoothing: var(--nile-webkit-font-smoothing, var(--ng-webkit-font-smoothing));
    -moz-osx-font-smoothing: var(--nile-moz-osx-font-smoothing, var(--ng-moz-osx-font-smoothing));
    text-rendering: var(--nile-text-rendering, var(--ng-text-rendering));
  }
`;

export default [styles];
